import {gql} from '@apollo/client';
import {ReviewTaskFiltersTypeInput} from '../types/ReviewTaskType';

export const GET_REVIEW_TASK_COUNT = gql`
    query GetReviewTaskCount($filters: ReviewTaskFiltersTypeInput!) {
        getReviewTaskCount(filters: $filters)
    }
`;

export interface GetReviewTaskCountResponse {
    getReviewTaskCount: number;
}

export interface GetReviewTaskCountVariables {
    filters: ReviewTaskFiltersTypeInput;
}
